import React from 'react';
import { cx } from '@/ui/utils/cx';

export type AppTextareaProps = React.TextareaHTMLAttributes<HTMLTextAreaElement> & {
  hasError?: boolean;
};

const AppTextarea = React.forwardRef<HTMLTextAreaElement, AppTextareaProps>(function AppTextarea(
  { className, hasError = false, ...rest },
  ref,
) {
  return (
    <textarea
      ref={ref}
      className={cx('app-control', hasError && 'app-control--error', className)}
      {...rest}
    />
  );
});

export default AppTextarea;
